import React,{ useState} from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import Loader from '../components/Loader';
import axios from 'axios';
import { CONFIG} from '../config';

const ExportExcel = ({ userId,filteredData,totalDLScore,reportDate, fileName = "DL_Report.xlsx" }) => {
  const [loading, setLoading] = useState(false);  
  const [error, setError] = useState("");
  const [sheet2Data, setSheet2Data] = useState("");
  const handleExport = async () => {
      
      const apiUrl = CONFIG.REACT_APP_BACKEND_URL+'/export_dl_score';
     // const apiUrl = 'https://divadevfalcon.azurewebsites.net/export_dl_score';

        if(userId){       
       try {
        const postData={
          "user_id":userId
         };
       axios.post(apiUrl,postData)
        .then(async response => {
          setLoading(false);
          console.log('response',response); 
          let sheet2Data=[];
          if(response && response.data && response.data>0){
            response.data.forEach((d) => {
              sheet2Data.push([d.Market,d["Market Unit"],d["Delivery Lead"],d["Contract ID"],d["Client"],d["TMS ID"],d["Team Name"],d["Category"],d["Check Name"],d["P/E"]]);
            });
          }    
         // setSheet2Data(response.data);  
           const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("DL Report");
      console.log('filteredData',filteredData);
      const dRow=worksheet.addRow(["Delivery Lead Score", totalDLScore]); 
      dRow.font = { bold: true };
      const rpRow=worksheet.addRow(["Reporting Period",reportDate]); 
      rpRow.font = { bold: true };
      const userRow=worksheet.addRow(["Report Generated by",userId]); 
      userRow.font = { bold: true };
    
      worksheet.addRow([]); // Optional: spacing row
    
      // Add header row
      const headers = [
        "Market/MU/Employee/TMS Name", // Will include Market/MU/Employee/TMS Name
        "Delivery Governance KPI",
        "ISA Compliance",
        "Tool Compliance",
        "Training Compliance",
        "Review Compliance",
        "Total NC Score",
      ];
      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };
  
      // Traverse filteredData like in your table
      filteredData.forEach((market) => {
        const marketName = Object.keys(market)[0];
        const marketInfo = market[marketName];
  
        const mRow = worksheet.addRow([marketName, ...getMetricValues(marketInfo.market_level_metrics)]);
        mRow.font = { bold: true };
  
        marketInfo.mu_level_metrics.forEach((muObj) => {
          const mu = Object.keys(muObj).find(k => !k.includes('md_') && !k.includes('dl_'));
          const muInfo = muObj[mu];
  
          const muRow = worksheet.addRow([`   ${mu}`, ...getMetricValues(muInfo)]);
          muRow.font = { bold: true };
  
          Object.entries(muObj)
            .filter(([k]) => k.includes('dl_level_metrics'))
            .forEach(([_, emps]) => {
              Object.entries(emps).forEach(([empName, empData]) => {
                const dl = empData?.dl_level || {};
                worksheet.addRow([`      ${empName}`, ...getMetricValues(dl)]);
  
                const tmsLevels = empData?.tms_level || {};
                Object.entries(tmsLevels).forEach(([tms, metrics]) => {
                  worksheet.addRow([
                    `         ${tms}`,
                    metrics["Delivery Governance KPIs"]?.count || 0,
                    metrics["ISA Compliance tracking KPIs"]?.count || 0,
                    metrics["ATCI Tool KPIs"]?.count || 0,
                    metrics["Training KPIs"]?.count || 0,
                    metrics["Review KPIs"]?.count || 0,
                    getTotal(metrics),
                  ]);
                   const checksDetialsObj = {};
                  let totalempcount=0;
                  if(emps && emps[empName] && emps[empName].tms_level && emps[empName].tms_level[tms]){
                    //   for (const group in emps[empName].tms_level[tmsName]) {
                         const groupData = emps[empName].tms_level[tms];
                         for (const key in groupData) {
                           const entry = groupData[key];
                       
                           if (!entry || typeof entry.count !== 'number' || typeof entry.line_items !== 'string') {
                             continue; // skip invalid data
                           }
                       
                           if (!checksDetialsObj[key]) {
                             checksDetialsObj[key] = { count: 0, line_items: [], totalline_items:[] };
                           }
                       
                           checksDetialsObj[key].count += entry.count;
                           totalempcount+=entry.count;
                           // Split by semicolon and trim each item
                           const items = entry.line_items.split(';').map(item => item.trim()).filter(Boolean);
                           //checksDetialsObj[key].line_items.push(...items);
                           //entry.totalline_items={ ...entry.line_items };
                           items.forEach(item => {
                             checksDetialsObj[key].totalline_items.push(item);
                             if (!checksDetialsObj[key].line_items.includes(item)) {
                               checksDetialsObj[key].line_items.push(item);
                             //  console.log('market,mu,dl,empName,tms',marketName,mu,empName,tms,);                  
                
                             }
                           });
                   
                         }
                    //   } 
                       console.log('checksDetialsObj',checksDetialsObj);
                       } 
                  //obj=[marketName,mu];
                });
              });
            });
        });
      });
  
      // Auto-width for readability
      worksheet.columns.forEach((col) => {
        let max = 10;
        col.eachCell?.((c) => {
          const len = c.value?.toString().length || 0;
          if (len > max) max = len;
        });
        col.width = max + 5;
      });

      const detailsSheet = workbook.addWorksheet("Check Level Details");

      // Headers
      const detailHeaders = ["Market", "Market Unit", "Delivery Lead", "Contract ID", "Client", "TMS ID", "Team Name", "Category", "Check Name","P/E"];
      const headerRow2 = detailsSheet.addRow(detailHeaders);
      headerRow2.font = { bold: true };
      //detailsSheet.addRow(sheet2Data);
      if(response && response.data && response.data.data && response.data.data.length>0){
      response.data.data.forEach((d) => {
          detailsSheet.addRow([d.Market,d["Market Unit"],d["Delivery Lead"],d["Contract ID"],d["Client"],d["TMS ID"],d["Team Name"],d["Category"],d["Check Name"],d["P/E"]]);
      });
    }
  
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer]), fileName);    
        })
        .catch(error => {  
          console.log('inside error',error);        
        })
      } catch (err) {
        setError("Failed to fetch data.");
      } finally {
        setLoading(true);
      }}
    };
    
    const getMetricValues = (metrics = {}) => [
      metrics["Delivery Governance KPIs"] || "",
      metrics["ISA Compliance tracking KPIs"] || "",
      metrics["ATCI Tool KPIs"] || "",
      metrics["Training KPIs"] || "",
      metrics["Review KPIs"] || "",
      metrics["Total"] || "",
    ];
  
    const getTotal = (obj = {}) =>
      (obj["Delivery Governance KPIs"]?.count || 0) +
      (obj["ISA Compliance tracking KPIs"]?.count || 0) +
      (obj["ATCI Tool KPIs"]?.count || 0) +
      (obj["Training KPIs"]?.count || 0) +
      (obj["Review KPIs"]?.count || 0);
  
    return <> {loading && <Loader loadingtxt='Loading delivery metrics details, Please hold on a moment'/>} 
    <button className="btn btn-primary bg-purple border-purple" onClick={handleExport}>Export to Excel</button></>;
  };

  export default ExportExcel;